<template>
  <div class="experiment ma-0">
    <v-tabs
      class="elevation-2"
      background-color="#f5f5f5"
      color="red"
      slider-size="4"
    >
      <v-tab disabled>
      </v-tab>
      <v-tab :href="`#tab-experiment-list`">
        {{ $t("manage.by_school.experiment.tab.list") }}
      </v-tab>
      <v-tab :href="`#tab-experiment-command`">
        {{ $t("manage.by_school.experiment.tab.command_list") }}
      </v-tab>
      <v-tab :href="`#tab-experiment-command-send`">
        {{ $t("manage.by_school.experiment.tab.command_send") }}
      </v-tab>
      <v-tab-item :value="'tab-experiment-list'">
        <ExperimentList />
      </v-tab-item>
      <v-tab-item :value="'tab-experiment-command'">
        <CommandList />
      </v-tab-item>
      <v-tab-item :value="'tab-experiment-command-send'">
        <CommandSend />
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
import ExperimentList from "@/components/management/experiment/ExperimentList.vue";
import CommandList from "@/components/management/experiment/CommandList.vue";
import CommandSend from "@/components/management/experiment/CommandSend.vue";

export default {
  name: "experiment",
  components: {
    ExperimentList,
    CommandList,
    CommandSend,
  },
  mixins: [],
  data: function () {
    return {
    };
  },
  mounted: function () {
  },
  methods: {
  },
  destroyed(){
  } 
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
</style>